import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { getMoment } from '../services/datetime.service';

@Pipe({
  name: 'dateTimePresentation'
})
export class DateTimePresentationPipe implements PipeTransform {

  constructor() { }

  public transform(value: string, args?: any): string {

    if (value === '0001-01-01T00:00:00+00:00' || value === '1900-01-01T00:00:00+00:00'
      || value === null || value === undefined || value === '') {
      return '-';
    } else {
      const format = `${environment.dateFormatSystem} ${environment.timeFormat}`;
      const message = getMoment(value, format).format(`${environment.dateFormatPresentation} ${environment.timeFormat}`);
      return message;
    }

  }

}
